import { render, staticRenderFns } from "./RegisterComplete.vue?vue&type=template&id=7d40ac82&scoped=true"
import script from "./RegisterComplete.vue?vue&type=script&lang=js"
export * from "./RegisterComplete.vue?vue&type=script&lang=js"
import style0 from "./RegisterComplete.vue?vue&type=style&index=0&id=7d40ac82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d40ac82",
  null
  
)

export default component.exports